import React, { FC, ReactElement } from 'react';
import { localizeType } from '../../commonType';
import ParseHtml from '../common/ParseHtml';
import withLocalization from '../hoc/withLocalization';

interface RoomPriceInfoProp {
  highSeasonCost: string;
  lowSeasonCost: string;
  localize: localizeType;
}
const RoomPriceInfo: FC<RoomPriceInfoProp> = (props: RoomPriceInfoProp): ReactElement => {
  const { highSeasonCost, lowSeasonCost, localize } = props;
  const tempHighSeasonCost = highSeasonCost ? highSeasonCost : '0';
  const tempLowSeasonCost = lowSeasonCost ? lowSeasonCost : '0';
  const isSamePrice = tempHighSeasonCost === tempLowSeasonCost;
  const localizeSamePriceString = localize(
    'preview-sales-engine.static-content.copy.select-offer-page.low-high-same-price',
    tempLowSeasonCost,
  );
  const localizeDifferentSeasonCostString = localize(
    'preview-sales-engine.static-content.copy.select-offer-page.low-high-diff-price',
    [tempLowSeasonCost, tempHighSeasonCost],
  );
  const priceDisplay = isSamePrice ? (
    <>
      <ParseHtml htmlInput={localizeSamePriceString}></ParseHtml>
    </>
  ) : (
    <>
      <ParseHtml htmlInput={localizeDifferentSeasonCostString}></ParseHtml>
    </>
  );

  return <>{priceDisplay}</>;
};
export default withLocalization(RoomPriceInfo);
